// ####   HOW TO BUILD   #####
// # Use correct section below
// # Set correct value for PUBLIC_URL in file .env
// # in cmd run 'set PUBLIC_URL=https://stage.learnwarecenter.se/lwc/&&npm run build' (OBS NOTERA att exemplet är för STAGE)
// ###########################

//  ####   HOW TO RUN locally   #####
//  # delete file .env (CHECKA INTE in borttagningen)
//  # in cmd run 'yarn start'

/**  Backend endpoints for the app and auth services. */

//var _host = "http://localhost";
//var _sslHost = "https://localhost";
//export const API_BASE_URL = `${_host}:5001/api`;
//export const AUTH_BASE_URL = `${_host}:5010/api`;
//export const SCORM_API_URL = `${_sslHost}:53480/Scorm`;
//export const LW_COURSE_API_URL = `${_host}:60200`;
//export const BASE_LOGIN_REDIRECT_URL = `${_host}:3000`;
//export const BASE_LOGIN_REDIRECT_URL_NO_LWC = `${_host}:3000`;
//export const ENVIRONMENT = "localhost";
//export const ENVIRONMENT_COLOR = "#33ccff";
//export const QAPI_URL = "https://qapi.learnwarecenter.se";

/** IIS deploy configuration for PROD. */
var _host = "https://learnwarecenter.se";
export const API_BASE_URL = `${_host}/lwcapi/api`;
export const AUTH_BASE_URL = `${_host}/auth/api`;
export const SCORM_API_URL = `${_host}/lwcscorm/scorm`;
export const LW_COURSE_API_URL = `${_host}/lwcommunicate`;
export const BASE_LOGIN_REDIRECT_URL = `${_host}/lwc`;
export const BASE_LOGIN_REDIRECT_URL_NO_LWC = `${_host}`;
export const ENVIRONMENT = "";
export const ENVIRONMENT_COLOR = "";
export const QAPI_URL = "https://qapi.learnwarecenter.se";

/** IIS deploy configuration for TEST. */
/* Efter bygge ändra i index.html:
<base href="/lwc/" target="_blank"/> => <base href="/lwctest/lwc/" target="_blank"/> */
//var _host = "https://login6.competencetool.se/lwctest";
//export const API_BASE_URL = `${_host}/lwcapi/api`;
//export const AUTH_BASE_URL = `${_host}/auth/api`;
//export const SCORM_API_URL = `${_host}/lwcscorm/scorm`;
//export const LW_COURSE_API_URL = `${_host}/lwcommunicate`;
//export const BASE_LOGIN_REDIRECT_URL = `${_host}/lwc`;
//export const BASE_LOGIN_REDIRECT_URL_NO_LWC = `${_host}`;
//export const BASE_URL = `${_host}`;
//export const ENVIRONMENT = "TEST";
//export const ENVIRONMENT_COLOR = "#90EE90";
//export const QAPI_URL = "https://qapi.learnwarecenter.se";
